<h2 mat-dialog-title>Dettagli richiesta</h2>

<mat-dialog-content>
  <!-- Stato in evidenza: stessa pillola a colore pieno delle chip di stato
       dell'elenco richieste. -->
  <div class="d-flex align-items-center gap-2 mb-2">
    <span
      class="izy-status-pill"
      [ngClass]="getStatusPillClass(referralRequest.status)"
    >
      {{ getReferralStatusLabel(referralRequest.status) }}
    </span>
  </div>

  <p class="text-muted small mb-0">
    Questa richiesta è {{ getReferralStatusDisplay(referralRequest.status) }}.
    Ti aggiorniamo noi quando il tuo bonus è pronto.
  </p>

  <div *ngIf="isLoading" class="text-center mt-3">
    <mat-spinner diameter="30"></mat-spinner>
    <p class="mt-2">Aggiornamento in corso...</p>
  </div>

  <mat-divider class="mt-3"></mat-divider>

  <p class="mt-3 mb-2">I dati che hai inserito:</p>

  <!-- Valori in sola lettura: stesso trattamento dei campi non modificabili
       del profilo e della card "Cliente selezionato" di nuova fattura - tratto
       tratteggiato e fondo appena velato di panna, perche' qui non si edita
       nulla. -->
  <div class="referral-details">
    <div class="referral-detail">
      <label class="referral-detail__label">Nome</label>
      <div class="referral-detail__value">
        {{ referralRequest.name }}
      </div>
    </div>

    <div class="referral-detail">
      <label class="referral-detail__label">Indirizzo mail</label>
      <div class="referral-detail__value referral-detail__value--with-action">
        <span class="referral-detail__text">{{ referralRequest.mail }}</span>
        <button
          mat-icon-button
          type="button"
          (click)="copyMailToClipboard()"
          matTooltip="Copia l'indirizzo mail."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
          aria-label="Copia indirizzo mail"
          class="referral-copy-btn custom-button-border"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>

    <div class="referral-detail">
      <label class="referral-detail__label">Telefono/cellulare</label>
      <div class="referral-detail__value referral-detail__value--with-action">
        <span class="referral-detail__text">{{ referralRequest.telephone }}</span>
        <button
          mat-icon-button
          type="button"
          (click)="copyNumberToClipboard()"
          matTooltip="Copia il numero di telefono."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
          aria-label="Copia numero di telefono"
          class="referral-copy-btn custom-button-border"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>

    <div class="referral-detail">
      <label class="referral-detail__label">È già una Partita IVA?</label>
      <div class="referral-detail__value">
        {{ referralRequest.is_already_partita_iva ? 'Sì' : 'No' }}
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-raised-button
    matButton="filled"
    type="button"
    (click)="confirm()"
    [disabled]="isLoading || referralForm.invalid"
    class="izy-button-primary custom-button-border"
  >
    <mat-icon>check</mat-icon>
    Fatto
  </button>
</mat-dialog-actions>
